module.exports = __webpack_public_path__ + "04_glasses_red.a270d5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/04_glasses_red.png
// module id = iw7F
// module chunks = 0